import type { ReactElement } from 'react'

import { Filter } from './Filter'
import { NewsList } from './NewsList'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/enlayout'
import { Head } from '@/components/enlayouts/Head'
import { Layout } from '@/components/enlayouts/Ir'

import { useMpocketScript } from '@/hooks/useMpocketScript'

export const NewsPage = () => {
  useMpocketScript('//irpocket.com/141A/irpocket/ir-news_en.js')
  // useMpocketScript('//irpocket.com/5882/irpocket/ir-news_en.js')

  // 初期状態は「すべて」がアクティブ
  const tagList = [
    { name: 'All', filterId: 'all', isActive: true },
    { name: 'Notice', filterId: 'oshirase', isActive: false },
    { name: 'Financial Related', filterId: 'kessan', isActive: false },
    { name: 'General Meeting of Shereholders', filterId: 'sokai', isActive: false },
  ]

  return (
    <Layout>
      <SectionTitle
        enTitleText="IR News"
        subTitleText=""
        color="normal"
      />
      <Spacer h={{ sp: 50, pc: 50 }} />
      <Filter tagList={tagList} />
      <Spacer h={{ sp: 40, pc: 80 }} />
      <NewsList />
    </Layout>
  )
}

NewsPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'Home', path: '/en' },
    { name: 'Investor Relations', path: '/en/ir' },
    { name: 'IR News', path: '' },
  ]

  return (
    <>
      <Head
        title="IR News"
        description="Latest IR information."
        ogp={{ url: 'en/ir/news/' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle=""
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}
